var _path, _g, _text, _text2, _text3, _text4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKhcWAddress = function SvgKhcWAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 730,
    height: 150,
    preserveAspectRatio: "xMinYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    d: "M6 6h410v140H6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6h12v140H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 75 80 5h5L35 75zM10 75l70 70h5L35 75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 6h8v140h-8z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 65,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 60,
    fontWeight: "bold"
  }, "\r\n    Keith's\r\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 125,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 60,
    fontWeight: "bold"
  }, "\r\n    Haircenter\r\n  ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 72,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 32,
    fontWeight: "bold"
  }, "\r\n    904 Green Bay,\r\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 108,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 32,
    fontWeight: "bold"
  }, "\r\n    WI 54304\r\n  ")));
};
export { SvgKhcWAddress as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzMwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDczMCAxNTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pbllNaWQgbWVldCI+DQogIDxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSI0MTAiIGhlaWdodD0iMTQwIiBmaWxsPSJub25lIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjQiLz4NCg0KICA8ZyBmaWxsPSJ3aGl0ZSI+DQogICAgPHJlY3QgeD0iNSIgeT0iNiIgd2lkdGg9IjEyIiBoZWlnaHQ9IjE0MCIvPg0KICAgIDxwb2x5Z29uIHBvaW50cz0iMTAsNzUgODAsNSA4NSw1IDM1LDc1Ii8+DQogICAgPHBvbHlnb24gcG9pbnRzPSIxMCw3NSA4MCwxNDUgODUsMTQ1IDM1LDc1Ii8+DQogICAgPHJlY3QgeD0iODAiIHk9IjYiIHdpZHRoPSI4IiBoZWlnaHQ9IjE0MCIvPg0KICA8L2c+DQoNCiAgPHRleHQgeD0iMTAwIiB5PSI2NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBIZWx2ZXRpY2EsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iNjAiIGZpbGw9IndoaXRlIiBmb250LXdlaWdodD0iYm9sZCI+DQogICAgS2VpdGgmYXBvcztzDQogIDwvdGV4dD4NCiAgPHRleHQgeD0iMTAwIiB5PSIxMjUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgSGVsdmV0aWNhLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjYwIiBmaWxsPSJ3aGl0ZSIgZm9udC13ZWlnaHQ9ImJvbGQiPg0KICAgIEhhaXJjZW50ZXINCiAgPC90ZXh0Pg0KDQogIDx0ZXh0IHg9IjQzMCIgeT0iNzIiIGZvbnQtZmFtaWx5PSJBcmlhbCwgSGVsdmV0aWNhLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjMyIiBmaWxsPSJ3aGl0ZSIgZm9udC13ZWlnaHQ9ImJvbGQiPg0KICAgIDkwNCBHcmVlbiBCYXksDQogIDwvdGV4dD4NCiAgPHRleHQgeD0iNDMwIiB5PSIxMDgiIGZvbnQtZmFtaWx5PSJBcmlhbCwgSGVsdmV0aWNhLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjMyIiBmaWxsPSJ3aGl0ZSIgZm9udC13ZWlnaHQ9ImJvbGQiPg0KICAgIFdJIDU0MzA0DQogIDwvdGV4dD4NCjwvc3ZnPg0K";